import { FaDownload, FaFileDownload, FaFileImport } from "react-icons/fa";
import { UploadBudgetAllocationsApi } from "../../services/Api";
import React, { useState, useContext, useRef, useMemo, useCallback } from "react";
import AppContext from "../../AppContext";
import BtnSpinner from "../../components/BtnSpinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Button } from 'react-bootstrap';

// Add custom styles for the upload area
const uploadAreaStyles = `
  .upload-area:hover {
    border-color: #007bff !important;
    background-color: #f8f9fa !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 123, 255, 0.15) !important;
  }
  
  .upload-area:not(:hover) {
    transition: all 0.3s ease;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = uploadAreaStyles;
  document.head.appendChild(styleSheet);
} 
const UploadBudgetAllocations = () => {
  const global = useContext(AppContext);
  const [file, setFile] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [success_msg, setSuccess_msg] = useState("");
  const [upload_status, setUpload_status] = useState(null);
  const [is_loading, setIs_loading] = useState(false);
  const [is_deleting, setIs_deleting] = useState(false);
  const [succ_msg, setSucc_msg] = useState("");
  const [rowData, setRowData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [isDragOver, setIsDragOver] = useState(false);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  // Handle file selection
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFile(file.name);
    }
  };

  // Handle drag and drop
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragOver(false);
    
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type.includes('sheet') || file.type.includes('csv') || file.name.endsWith('.xlsx') || file.name.endsWith('.xls') || file.name.endsWith('.csv')) {
        setSelectedFile(file);
        setFile(file.name);
      } else {
        alert('Please select a valid Excel or CSV file');
      }
    }
  };

  // Handle upload button click
  const handleUpload = () => {
    if (!selectedFile) {
      alert("Please select a file first");
      return;
    }

    setIs_loading(true);

    const data = new FormData();
    data.append("Codes", selectedFile);

    UploadBudgetAllocationsApi(data).then((res) => {
      setIs_loading(false);
      setSuccess_msg(res.data["message"]);
      setUpload_status(res.data["status"]);
      setRowData(res.data["data"] || []);
      setErrorData(res.data["data"] || []);
      setFile("");
      setSelectedFile(null);
    }).catch((error) => {
      setIs_loading(false);
      console.error("Upload error:", error);
    });
  };

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  //  {
  //           "staff_id": "SOM109",
  //           "staff_name": " Ayan Mohamed Ahmed",
  //           "status": 10001,
  //           "message": "Allocation was updated successful",
  //           "amount": 757.5,
  //           "percentage": 122.67,
  //           "project_id": "5721037c-47a4-4628-a307-4471dc19680d",
  //           "project_name": "SIMCH-Payroll Project 2025",
  //           "budget_line": "67709dd1-b092-40d9-9d8a-1904793c58dd",
  //           "budget_name": "Salary for Nurse",
  //           "month": 6,
  //           "year": 2025
  //       }
  const StatusCellRenderer = (props) => {
    if (props.value === 10001) {
      return (
        <span
          style={{
            display: 'inline-block',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'green',
            color: 'white',
            textAlign: 'center',
            lineHeight: '20px',
          }}
        >
          <i className="fa fa-check-circle" style={{ color: 'white' }}></i>
        </span>
      );
    } else if (props.value === 10002) {
      return (
        <span
          style={{
            display: 'inline-block',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'orange',
            color: 'white',
            textAlign: 'center',
            lineHeight: '20px',
          }}
        >
          <i className="fa fa-exclamation-triangle" style={{ color: 'white' }}></i>
        </span>
      );
    } else {
      return (
        <span
          style={{
            display: 'inline-block',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'red',
            color: 'white',
            textAlign: 'center',
            lineHeight: '20px',
          }}
        >
          <i className="fa fa-times-circle" style={{ color: 'white' }}></i>
        </span>
      );
    }
  };
  // Column definitions
  const columnDefs = [
    {
      headerName: "#",
      filter: false,
      maxWidth: 70,
      sortable: true,
      valueFormatter: (params) => {
        const nodeId = parseInt(params.node.id, 10);
        return isNaN(nodeId) ? '' : nodeId + 1;
      },
    },
    {
      headerName: "Staff ID",
      field: "staff_id",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Staff Name",
      field: "staff_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Project Name",
      field: "project_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Budget Name",
      field: "budget_name",
      sortable: true,
      filter: true,
    },

    {
      headerName: "Month",
      field: "month",
      sortable: true,
      filter: true,
      valueFormatter: function (params) {
        const months = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        return months[params.value - 1];  // Adjust for zero-based index
      }
    },
    {
      headerName: "Year",
      field: "year",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Amount",
      field: "amount",
      sortable: true,
      filter: true,
    },
    {
      headerName: "%",
      field: "percentage",
      sortable: true,
      filter: true,
      valueFormatter: function (params) {
        return `${params.value}%`;
      }
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      filter: true,
      cellRendererFramework: StatusCellRenderer,
    }

    // Add other column definitions here as needed
  ];
  // const onExportToExcel = () => {
  //   gridRef.current.api.exportDataAsExcel();
  // };
  // Grid ready callback
  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.showLoadingOverlay();
  };

  // Error table component
  const ErrorTable = ({ errorData }) => {
    const errorRecords = errorData.filter(record => record.errors && record.errors.length > 0);
    const successRecords = errorData.filter(record => !record.errors || record.errors.length === 0);
    
    if (errorRecords.length === 0) return null;

    return (
      <div className="mt-4">
        {/* Summary */}
        <div className="alert alert-warning" role="alert">
          <h4 className="alert-heading">
            <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
            Upload Summary
          </h4>
          <p className="mb-0">
            <strong>Total Records:</strong> {errorData.length} | 
            <strong style={{ color: 'green', marginLeft: '10px' }}> Successful:</strong> {successRecords.length} | 
            <strong style={{ color: 'red', marginLeft: '10px' }}> Failed:</strong> {errorRecords.length}
          </p>
        </div>

        <h4 style={{ color: 'red', marginBottom: '15px' }}>
          <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
          Validation Errors Found
        </h4>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Staff ID</th>
                <th>Staff Name</th>
                <th>Errors</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {errorRecords.map((record, index) => (
                <tr key={index}>
                  <td><strong>{record.staff_id}</strong></td>
                  <td>{record.staff_name}</td>
                  <td>
                    <ul className="mb-0">
                      {record.errors.map((error, errorIndex) => (
                        <li key={errorIndex} style={{ color: 'red' }}>{error}</li>
                      ))}
                    </ul>
                  </td>
                  <td style={{ color: 'red' }}>{record.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  return (
    <div>
      <>
        <div style={{ margin: "auto", width: "98%" }}>
          {succ_msg}
          <p
            style={{
              textAlign: "center",
              color: "red",
              fontWeight: "bold",
              fontSize: 25,
            }}
            id="msg"
          />

          {/* <form id="fileUpload_form"> */}
          <center>
            <div className="card" style={{ 
              width: "90%", 
              margin: "auto", 
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
              border: 'none'
            }}>
              <div className="card-header" style={{ 
                backgroundColor: '#f8f9fa', 
                borderBottom: '1px solid #dee2e6',
                borderRadius: '16px 16px 0 0',
                padding: '20px'
              }}>
                <div className="text-center">
                  <img
                    src="/icons/excel.png"
                    style={{ height: 60, width: 60, marginBottom: '10px' }}
                  />
                  <h3 style={{ margin: '0', color: '#495057' }}>Upload Budget Allocations</h3>
                  <p style={{ margin: '5px 0 0 0', color: '#6c757d' }}>Upload your Excel file to process budget allocations</p>
                </div>
              </div>
              
              <div className="card-body" style={{ padding: '30px' }}>
                <div className="text-center mb-4">
                  <a
                    href="/excel_files/.xlsx"
                    className="btn btn-outline-primary"
                    download
                    style={{
                      borderRadius: '8px',
                      padding: '10px 20px',
                      fontWeight: '500'
                    }}
                  >
                    <FaDownload style={{ marginRight: '8px' }} />
                    Download Sample Excel File
                  </a>
                </div>
                <div className="form-group">
                  {/* Modern File Upload Area */}
                  <div 
                    className="upload-area"
                    style={{
                      border: `2px dashed ${isDragOver ? '#007bff' : selectedFile ? '#28a745' : '#dee2e6'}`,
                      borderRadius: '12px',
                      padding: '40px 20px',
                      textAlign: 'center',
                      backgroundColor: isDragOver ? '#e3f2fd' : selectedFile ? '#f8f9fa' : '#ffffff',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      transform: isDragOver ? 'scale(1.02)' : 'scale(1)',
                      boxShadow: isDragOver ? '0 8px 25px rgba(0, 123, 255, 0.15)' : selectedFile ? '0 4px 15px rgba(40, 167, 69, 0.1)' : 'none'
                    }}
                    onClick={() => document.getElementById('fileInput').click()}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <input
                      id="fileInput"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={handleFileSelect}
                      accept=".xlsx, .xls, .csv"
                      name="file"
                      aria-label="Select file to upload"
                      required
                    />
                    
                    {isDragOver ? (
                      <div>
                        <div style={{ fontSize: '48px', color: '#007bff', marginBottom: '16px' }}>
                          <i className="fa fa-cloud-upload-alt"></i>
                        </div>
                        <h4 style={{ color: '#007bff', marginBottom: '8px' }}>Drop File Here</h4>
                        <p style={{ color: '#007bff', marginBottom: '0' }}>
                          Release to upload your file
                        </p>
                      </div>
                    ) : !selectedFile ? (
                      <div>
                        <div style={{ fontSize: '48px', color: '#6c757d', marginBottom: '16px' }}>
                          <FaFileImport />
                        </div>
                        <h4 style={{ color: '#495057', marginBottom: '8px' }}>Choose File to Upload</h4>
                        <p style={{ color: '#6c757d', marginBottom: '0' }}>
                          Drag and drop your Excel file here, or click to browse
                        </p>
                        <small style={{ color: '#adb5bd' }}>
                          Supported formats: .xlsx, .xls, .csv
                        </small>
                      </div>
                    ) : (
                      <div>
                        <div style={{ fontSize: '48px', color: '#28a745', marginBottom: '16px' }}>
                          <i className="fa fa-check-circle"></i>
                        </div>
                        <h4 style={{ color: '#28a745', marginBottom: '8px' }}>File Selected</h4>
                        <p style={{ color: '#495057', marginBottom: '0', wordBreak: 'break-all' }}>
                          <strong>{selectedFile.name}</strong>
                        </p>
                        <small style={{ color: '#6c757d' }}>
                          {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                        </small>
                        <div className="mt-2">
                          <button 
                            type="button" 
                            className="btn btn-sm btn-outline-secondary"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedFile(null);
                              setFile('');
                              document.getElementById('fileInput').value = '';
                            }}
                          >
                            <i className="fa fa-times"></i> Remove
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  {/* Modern Upload Button */}
                  <div className="text-center mt-4">
                    {is_loading ? (
                      <BtnSpinner
                        is_loading={is_loading}
                        text={"Processing..."}
                        color={"white"}
                        class={"btn btn-primary btn-lg px-5"}
                        size="5"
                      />
                    ) : (
                      <button 
                        type="button" 
                        className={`btn btn-lg px-5 ${selectedFile ? 'btn-success' : 'btn-outline-secondary'}`}
                        onClick={handleUpload}
                        disabled={!selectedFile}
                        style={{
                          borderRadius: '8px',
                          fontWeight: '500',
                          textTransform: 'none',
                          boxShadow: selectedFile ? '0 4px 12px rgba(40, 167, 69, 0.3)' : 'none',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <FaFileImport style={{ marginRight: '8px' }} />
                        {selectedFile ? 'Upload File' : 'Select File First'}
                      </button>
                    )}
                  </div>
                  
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 25,
                    }}
                  >
                    {success_msg && upload_status === 10001 && (
                      <span style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                      }}>
                        <i className="fa fa-check-circle" style={{ color: 'green' }} aria-hidden="true"></i>
                        <h1 style={{ color: "green", marginLeft: '8px' }}>{success_msg}</h1>
                      </span>)}
                    {success_msg && upload_status === 10002 && (
                      <span style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                      }}>
                        <i className="fa fa-exclamation-triangle" style={{ color: 'orange' }} aria-hidden="true"></i>
                        <h1 style={{ color: "orange", marginLeft: '8px' }}>Upload failed - Please review errors</h1>
                        <hr/>

                      </span>)}
                      {success_msg}
                  </p>
                </div>
              
                {/* Show AgGrid only for successful uploads (status 10001) */}
                {upload_status === 10001 && (
                  <div className="ag-theme-alpine" style={{ width: '100%', backgroundColor: 'black' }}>
                    {rowData.length > 0 ? (
                      <AgGridReact
                        suppressLoadingOverlay={true}  // Disable the loading overlay
                        suppressNoRowsOverlay={true}
                        ref={gridRef}
                        suppressMenuHide={true}
                        // overlayLoadingTemplate='<span class="ag-overlay-loading-center"> Uploaded Budget Allocations...</span>'
                        rowData={rowData.length > 0 ? rowData : []} // Ensuring rowData is not undefined or null
                        onGridReady={onGridReady}
                        domLayout={"autoHeight"}
                        animateRows={true}
                        onRowDoubleClicked={(e) => console.log(e.data)}
                        pagination={true}
                        paginationPageSize={100}
                        defaultColDef={defaultColDef}
                        resizable={true}
                        enableCellTextSelection={true}
                        suppressCellSelection={true}
                        columnDefs={columnDefs}
                      />) : (<div></div>)}
                  </div>
                )}

                {/* Show error table for validation failures (status 10002) */}
                {upload_status === 10002 && (
                  <ErrorTable errorData={errorData} />
                )}
              </div>
            </div>
          </center>
          {/* </form> */}
        </div>
        <br />
        <br />
      </>
    </div>
  );
};

export default UploadBudgetAllocations;
